import { PDFDocument } from "pdf-lib";
// Access global pdfjsLib from CDN
const pdfjsLib = window['pdfjs-dist/build/pdf'];

if (pdfjsLib) {
  pdfjsLib.GlobalWorkerOptions.workerSrc =
    'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
}

const actions = {
 resolveError(context, data) {
  return new Promise((_resolve, reject) => {
    const err = data?.err;
    const response = err?.response;
    const errorData = response?.data;
    // Extract message safely (supports ALL API formats)
    const baseMessage =
      errorData?.error?.message ||
      errorData?.message ||
      errorData?.ErrorMaster?.error?.message ||
      data?.errBlob?.error?.message ||
      'Apologies! Currently we are experiencing heavy load. Please try again in sometime!';
    // Append support line to all errors
    const message = baseMessage;

    // Extract error code safely
    const code =
      errorData?.error?.code ||
      errorData?.code ||
      errorData?.ErrorMaster?.error?.code ||
      data?.errBlob?.error?.code ||
      null;

    // Store error code
    if (code) {
      context.commit('SET_ERROR_CODE', code);
    }

    // Store error message
    if (!data.hideError) {
      context.commit('SET_ERROR_MESSAGE', message);
    }

    // Status-based API errors
    if (response && [400, 504].includes(response.status)) {
      return reject(new Error(message));
    }

    // Normal API errors with response
    if (response && errorData) {
      return reject(new Error(message));
    }

    // Blob errors
    if (data.errBlob?.error) {
      return reject(new Error(message));
    }

    // Default fallback
    return reject(new Error(message));
  });
},
  resolveErrorDigiLockerKarzaOtp(context, data) {
    return new Promise((_resolve, reject) => {
      context.commit('SET_ERROR_CODE', data?.err?.response?.data?.error?.code);
      if (data.err?.response.data.error.code === 'EPL-10000') {
        reject(new Error(data.err.response.data.error.code));
      } else if (data.err?.response?.data) {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', data.err.response.data.error.message);
        }
        reject(new Error(data.err.response.data.error.message));
      } else if (data.errBlob?.error) {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', data.errBlob.error.message);
        }
        reject(new Error(data.errBlob.error.message));
      } else {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', 'Apologies! Currently we are experiencing heavy load. Please try again in sometime!');
        }
        reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
      }
    });
  },
  resolveErrorDisablePopUp(context, data) {
    return new Promise((_resolve, reject) => {
      context.commit('SET_ERROR_CODE', data?.err?.response?.data?.error?.code);
      if (data.err?.response?.data) {
        if (!data.hideError) {
          reject(new Error(data.err.response.data.error.message));
        }
      } else if (data.errBlob?.error) {
        if (!data.hideError) {
          reject(new Error(data.errBlob.error.message));
        }
      } else if (!data.hideError) {
          reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
        }
    });
  },
  resolveErrorCodeForEmanDateKyc(context, data) {
    return new Promise((_resolve, reject) => {
      context.commit('SET_ERROR_CODE', data?.err?.response?.data?.error?.code);
      if (data.err?.response?.data) {
        if (!data.hideError) {
          if (data.err.response.data.error.code === 'EPL-10000') {
            reject(new Error(data.err.response.data.error.code));
          } else {
            reject(new Error(data.err.response.data.error.message));
          }
        }
      } else if (data.errBlob?.error) {
        if (!data.hideError) {
          reject(new Error(data.errBlob.error.message));
        }
      } else if (!data.hideError) {
        reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
      }
    });
  },
  resolveErrorGatewayTimeOut(context, data) {
    return new Promise((_resolve, reject) => {
      context.commit('SET_ERROR_CODE', data?.err?.response?.data?.error?.code);
      // if (data.err?.response?.status === 401) {
      //   this.$router.push({
      //     name: 'Back To GPay',
      //     query: {
      //       message: 'Session Expired Please Try Again!'
      //     }
      //   });
      //   reject(new Error(data.err.response.data.error.message));
      // }
      if (data.err?.response?.status === 400 || data.err?.response?.status === 504) {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', 'Apologies! Currently we are experiencing heavy load. Please try again in sometime!');
        }
        reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
      }
      if (data.err?.response?.data) {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', data.err.response.data.error.message);
        }
        if (data.errorCode) {
          context.commit('SET_ERROR_CODE', data.err.response.data.error.code);
        }
        reject(new Error(data.err.response.data.error.message));
      } else if (data.errBlob?.error) {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', data.errBlob.error.message);
        }
        reject(new Error(data.errBlob.error.message));
      } else {
        if (!data.hideError) {
          context.commit('SET_ERROR_MESSAGE', 'Apologies! Currently we are experiencing heavy load. Please try again in sometime!');
        }
        reject(new Error('Apologies! Currently we are experiencing heavy load. Please try again in sometime!'));
      }
    });
  },
  async checkPdfPasswordProtected(_context, file) {
    try {
      const typedArray = new Uint8Array(await file.arrayBuffer());
      await pdfjsLib.getDocument({ data: typedArray }).promise;
      return false; // not password protected
    } catch (err) {
      if (err?.name === 'PasswordException') {
        return true; // password protected
      }
      throw err; // other error
    }
  },
  unlockPdfWithPassword(_context, { file, password }) {
    return new Promise((resolve, reject) => {
      const processFile = async () => {
        try {
          const typedArray = new Uint8Array(await file.arrayBuffer());
          // Open with password using pdf.js
          const pdfDoc = await pdfjsLib.getDocument({
            data: typedArray,
            password,
          }).promise;
          // Create new PDF (without password)
          const newPdf = await PDFDocument.create();
          // Collect render promises
          const renderTasks = [];
          for (let i = 1; i <= pdfDoc.numPages; i += 1) {
            const pageNumber = i;
            renderTasks.push(
              (async () => {
                const page = await pdfDoc.getPage(pageNumber);
                const viewport = page.getViewport({ scale: 1.0 });
                // Render page to canvas
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                await page.render({ canvasContext: context, viewport }).promise;
                // Convert canvas to PNG
                const png = canvas.toDataURL("image/png").split(",")[1];
                const pngBytes = Uint8Array.from(atob(png), (c) => c.charCodeAt(0));
                // Embed into new PDF
                const img = await newPdf.embedPng(pngBytes);
                const newPage = newPdf.addPage([viewport.width, viewport.height]);
                newPage.drawImage(img, {
                  x: 0,
                  y: 0,
                  width: viewport.width,
                  height: viewport.height,
                });
              })()
            );
          }
          // Process all pages
          await Promise.all(renderTasks);
          // Save unlocked PDF
          const pdfBytes = await newPdf.save();
          const unlockedFile = new File(
            [pdfBytes],
            file.name.replace(/\.pdf$/, ".pdf"),
            {
              type: "application/pdf",
              lastModified: Date.now(),
            }
          );
          resolve({
            // pdfDoc,
            unlockedFile,
          });
        } catch (err) {
          if (err?.name === "PasswordException") {
            reject(new Error("Incorrect password. Please enter correct password"));
          } else {
            reject(err);
          }
        }
      };
      processFile();
    });
  },
};
export default actions;
